export const LINKS = {
  home: '/',
  about: '/about',
  contact: '/contact',
  service: '/service',
  resume: '/resume',
  tools: '/tools'
}
